import { gql } from '__generated__';

export default gql(`
  mutation AddTicketNumberSequence($input: AddTicketNumberSequenceInput!) {
    addTicketNumberSequence(input: $input) {
      id
      title
      assigned_ticket_number_count
      potential_ticket_number_count
      locked_ticket_number_count
    }
  }
`);
